import { useAppSelector } from "../useStore";
import { PersonaRole } from "@xemplo/gp-types";

export const useIsUserInRole = (roleCodes?: PersonaRole[]) => {
  const member = useAppSelector((state: any) => state.member);
  if (!roleCodes) return true;
  return roleCodes.includes(member?.details?.selectedRole?.role?.name);
};
